import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getAgreementsQueryOptions } from '@/_pages/agreements/api-service';

export const Route = createFileRoute('/_private/agreements/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={8} />,
});
